import axios from 'axios';

// API configuration based on environment
const API_URL = process.env.NODE_ENV === 'production'
  ? "https://dev.review-lens.liquidnitro.games"
  : "http://localhost:5000";

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;